import styled from "styled-components";
import { rem } from "polished";

export default styled.div.attrs({
  className: "input-group",
})`
  width: 100%;
  &:not(:last-child) {
    margin-bottom: 1.5em;
  }
  input:not([type="checkbox"]),
  select,
  textarea {
    height: ${rem("50px")};
    width: 100%;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    letter-spacing: 0.14px;
    padding: 0 1em;
    font-size: ${rem("14px")};
    font-weight: 300;
    color: #595f62;
    letter-spacing: 0.14px;
    &:active,
    &:focus {
      outline: none;
      border: 1.5px solid ${({ theme }) => theme.primary};
    }
    &:invalid:not([value=""]) {
      color: #222222;
      border: 1.5px solid #ff5e5e;
    }
  }

  input::placeholder {
    color: #595f62;
    font-size: ${rem("14px")};
    letter-spacing: 0.14px;
    font-weight: 300;
  }
  label {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 0.9rem;
    line-height: ${rem("20px")};
    letter-spacing: 0px;
    color: #03232e;
    margin-bottom: 0.5em;
  }
  textarea {
    height: ${rem("108px")};
    padding: 1em;
  }
  p.error-msg {
    text-align: left;
    margin: 0px;
    margin-top: 0.5em;
    font-size: ${rem("13px")};
    letter-spacing: ${rem("0.13px")};
    color: #ff5e5e;
    opacity: 1;
  }
  div.password-container {
    position: relative;
    input {
      padding-right: 4em;
    }
    button {
      position: absolute;
      cursor: pointer;
      background: none;
      outline: none;
      border: none;
      top: 50%;
      transform: translateY(-50%);
      right: 1em;
      .icon {
        color: ${({ theme }) => theme.primary};
        font-size: 1.5rem;
      }
    }
  }
`;
